import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyPortal/ComplaintReqs/ComplaintReqs';

function* getComplaintsList(action) {
    try {
        const result = yield call(req.getComplaintsListReq, action);
        if (result?.success === true) {
            yield put({
                type: types.SOCIETY_GET_COMPLAINTS_LIST_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.SOCIETY_GET_COMPLAINTS_LIST_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_COMPLAINTS_LIST_FAILURE, message: e?.message });
    }
}

function* getComplaintDetails(action) {
    try {
        const result = yield call(req.getComplaintDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_COMPLAINT_DETAILS_FAILURE, message: e?.message });
    }
}

function* createComplaint(action) {
    try {
        const result = yield call(req.createComplaintReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_CREATE_COMPLAINT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_COMPLAINT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_CREATE_COMPLAINT_FAILURE, message: e?.message });
    }
}

function* updateComplaint(action) {
    try {
        const result = yield call(req.updateComplaintReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_COMPLAINT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_COMPLAINT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_UPDATE_COMPLAINT_FAILURE, message: e?.message });
    }
}

function* deleteComplaint(action) {
    try {
        const result = yield call(req.deleteComplaintReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_DELETE_COMPLAINT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_COMPLAINT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_DELETE_COMPLAINT_FAILURE, message: e?.message });
    }
}

function* changeComplaintStatus(action) {
    try {
        const result = yield call(req.changeComplaintStatusReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_CHANGE_COMPLAINT_STATUS_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CHANGE_COMPLAINT_STATUS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_CHANGE_COMPLAINT_STATUS_FAILURE, message: e?.message });
    }
}

function* assignComplaint(action) {
    try {
        const result = yield call(req.assignComplaintReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_ASSIGN_COMPLAINT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_ASSIGN_COMPLAINT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_ASSIGN_COMPLAINT_FAILURE, message: e?.message });
    }
}

function* addComplaintComment(action) {
    try {
        const result = yield call(req.addComplaintCommentReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_ADD_COMPLAINT_COMMENT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_ADD_COMPLAINT_COMMENT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_ADD_COMPLAINT_COMMENT_FAILURE, message: e?.message });
    }
}

function* uploadComplaintAttachments(action) {
    try {
        const result = yield call(req.uploadComplaintAttachmentsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS_FAILURE, message: e?.message });
    }
}

function* deleteComplaintAttachment(action) {
    try {
        const result = yield call(req.deleteComplaintAttachmentReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_DELETE_COMPLAINT_ATTACHMENT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_COMPLAINT_ATTACHMENT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_DELETE_COMPLAINT_ATTACHMENT_FAILURE, message: e?.message });
    }
}

function* getComplaintCategories(action) {
    try {
        const result = yield call(req.getComplaintCategoriesReq, action);
        if (result?.success === true) {
            yield put({
                type: types.SOCIETY_GET_COMPLAINT_CATEGORIES_SUCCESS,
                payload: { rows: result.data },
            });
        } else {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_CATEGORIES_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_COMPLAINT_CATEGORIES_FAILURE, message: e?.message });
    }
}

function* getComplaintCategoriesMulti(action) {
    try {
        const result = yield call(req.getComplaintCategoriesMultiReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_FAILURE, message: e?.message });
    }
}

function* bulkCreateComplaintCategories(action) {
    try {
        const result = yield call(req.bulkCreateComplaintCategoriesReq, action);
        if (result?.success === true) {
            // The result.data payload has { created[], skipped[], failed[], ...counts }
            yield put({ type: types.SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            const message = result?.response?.data?.message;
            yield put({ type: types.SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES_FAILURE, message });
            action.data?.onError?.({ message, result });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES_FAILURE, message: e?.message });
        action.data?.onError?.({ message: e?.message, error: e });
    }
}

function* createComplaintCategory(action) {
    try {
        const result = yield call(req.createComplaintCategoryReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_CREATE_COMPLAINT_CATEGORY_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            const message = result?.response?.data?.message;
            yield put({ type: types.SOCIETY_CREATE_COMPLAINT_CATEGORY_FAILURE, message });
            action.data?.onError?.({ message, result });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_CREATE_COMPLAINT_CATEGORY_FAILURE, message: e?.message });
        action.data?.onError?.({ message: e?.message, error: e });
    }
}

function* updateComplaintCategory(action) {
    try {
        const result = yield call(req.updateComplaintCategoryReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_COMPLAINT_CATEGORY_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_COMPLAINT_CATEGORY_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_UPDATE_COMPLAINT_CATEGORY_FAILURE, message: e?.message });
    }
}

function* deleteComplaintCategory(action) {
    try {
        const result = yield call(req.deleteComplaintCategoryReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_DELETE_COMPLAINT_CATEGORY_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_COMPLAINT_CATEGORY_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_DELETE_COMPLAINT_CATEGORY_FAILURE, message: e?.message });
    }
}

function* getComplaintAuditLog(action) {
    try {
        const result = yield call(req.getComplaintAuditLogReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_AUDIT_LOG_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_AUDIT_LOG_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_COMPLAINT_AUDIT_LOG_FAILURE, message: e?.message });
    }
}

function* rateComplaint(action) {
    try {
        const result = yield call(req.rateComplaintReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_RATE_COMPLAINT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_RATE_COMPLAINT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_RATE_COMPLAINT_FAILURE, message: e?.message });
    }
}

function* getEmployeeComplaints(action) {
    try {
        const result = yield call(req.getEmployeeComplaintsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_EMPLOYEE_COMPLAINTS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_EMPLOYEE_COMPLAINTS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_EMPLOYEE_COMPLAINTS_FAILURE, message: e?.message });
    }
}

function* getComplaintStats(action) {
    try {
        const result = yield call(req.getComplaintStatsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_STATS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_STATS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_COMPLAINT_STATS_FAILURE, message: e?.message });
    }
}

function* getComplaintEnums(action) {
    try {
        const result = yield call(req.getComplaintEnumsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_ENUMS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_COMPLAINT_ENUMS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_COMPLAINT_ENUMS_FAILURE, message: e?.message });
    }
}

export default function* ComplaintSaga() {
    yield takeLatest(types.SOCIETY_GET_COMPLAINTS_LIST, getComplaintsList);
    yield takeLatest(types.SOCIETY_GET_COMPLAINT_DETAILS, getComplaintDetails);
    yield takeLatest(types.SOCIETY_CREATE_COMPLAINT, createComplaint);
    yield takeLatest(types.SOCIETY_UPDATE_COMPLAINT, updateComplaint);
    yield takeLatest(types.SOCIETY_DELETE_COMPLAINT, deleteComplaint);
    yield takeLatest(types.SOCIETY_CHANGE_COMPLAINT_STATUS, changeComplaintStatus);
    yield takeLatest(types.SOCIETY_ASSIGN_COMPLAINT, assignComplaint);
    yield takeLatest(types.SOCIETY_ADD_COMPLAINT_COMMENT, addComplaintComment);
    yield takeLatest(types.SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS, uploadComplaintAttachments);
    yield takeLatest(types.SOCIETY_DELETE_COMPLAINT_ATTACHMENT, deleteComplaintAttachment);
    yield takeLatest(types.SOCIETY_GET_COMPLAINT_ENUMS, getComplaintEnums);
    yield takeLatest(types.SOCIETY_GET_COMPLAINT_STATS, getComplaintStats);
    yield takeLatest(types.SOCIETY_GET_COMPLAINT_CATEGORIES, getComplaintCategories);
    yield takeLatest(types.SOCIETY_CREATE_COMPLAINT_CATEGORY, createComplaintCategory);
    yield takeLatest(types.SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES, bulkCreateComplaintCategories);
    yield takeLatest(types.SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI, getComplaintCategoriesMulti);
    yield takeLatest(types.SOCIETY_UPDATE_COMPLAINT_CATEGORY, updateComplaintCategory);
    yield takeLatest(types.SOCIETY_DELETE_COMPLAINT_CATEGORY, deleteComplaintCategory);
    yield takeLatest(types.SOCIETY_GET_EMPLOYEE_COMPLAINTS, getEmployeeComplaints);
    yield takeLatest(types.SOCIETY_RATE_COMPLAINT, rateComplaint);
    yield takeLatest(types.SOCIETY_GET_COMPLAINT_AUDIT_LOG, getComplaintAuditLog);
}
